export const initialData = {
  init: false,
  fields: {
    OfficeLocationID: null,
    FirmSizeID: null,
    Site: '',
    About: '',
    Esg: 'Both',
    Diversity: 'Both',
    Verified: null,
  },
  options: {
    FirmSizeID: [],
  },
};
